export default "__VITE_ASSET__D8akd3Jt__"